import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  meetingRule: (state: State) => state.meetingRule,
  meetingRuleInitData: (state: State) => state.meetingRuleInitData,
  meetingRules: (state: State) => state.meetingRules,
  meetingRuleCount: (state: State) => state.meetingRuleCount,
} as GetterTree<State, any>;